/**
 * Token storage for the admin console.
 *
 * In-memory access token for API calls. Tab-scoped copies for reload
 * survival live in `admin-session-storage.ts` (sessionStorage only, never
 * localStorage).
 *
 * This module exists so the rest of the codebase has a single import surface;
 * if the backend opts for bearer-in-memory tokens later, only this file changes.
 *
 * TODO(backend-handshake): finalise whether tokens are cookie-only or paired
 * with a short-lived access token. Update accordingly.
 */

let inMemoryAccessToken: string | null = null;

export function setInMemoryAccessToken(token: string | null): void {
  inMemoryAccessToken = token;
}

export function getInMemoryAccessToken(): string | null {
  return inMemoryAccessToken;
}

export function clearInMemoryAccessToken(): void {
  inMemoryAccessToken = null;
}
